import React from 'react';
import Typography from '@material-ui/core/Typography';
import { Dialog } from '@shared/components';
import { IconButton } from '@material-ui/core';
import SuccessIcon from '@assets/icons/done-green.svg';
import ErrorIcon from '@assets/icons/close-circle-red.svg';
import ErrorSymbol from '@assets/icons/error.svg';
import LoadingGif from '@assets/icons/spinner-144x144px.gif';
import Button from '@material-ui/core/Button';
import useStyles from './style';
import clsx from 'clsx';

const ActionDialog = ({
  content = null,
  contentText = 'Success! Your new product has been added.',
  contentVariant = 'h6',
  heading = 'New Product Added',
  isLoading = false,
  onClose = null,
  open = false,
  isError = false,
  contentAction = false,
  contentActionText = '',
  customIcon = null,
  status = '',
}) => {
  const ButtonText = status === 'Error' ? 'Close' : 'Home';
  const classes = useStyles();
  return (
    <Dialog
      classes={{
        paper: classes.toastDialog,
      }}
      open={open}
      onClose={onClose}
      centered
    >
      <Dialog.Title hasClose={true}>
        <Typography variant='h5' className='pt-2 align-center bold-font'>
          {heading}
        </Typography>
      </Dialog.Title>
      <Dialog.Content>
        {content ? (
          <>{content}</>
        ) : (
          <div className='pt-2 align-center'>
            {isLoading ? (
              <IconButton disabled className='mt-8 mb-2'>
                <img
                  src={LoadingGif}
                  alt='success'
                  // width='96'
                />
              </IconButton>
            ) : (
              <IconButton disabled className='mt-5 mb-2'>
                <img
                  src={
                    customIcon ||
                    (isError
                      ? status === 'Error'
                        ? ErrorSymbol
                        : ErrorIcon
                      : SuccessIcon)
                  }
                  alt='success'
                  width='96'
                />
              </IconButton>
            )}
            <Typography
              variant={contentVariant}
              className={clsx('mt-3', {
                'color-error': isError,
                [classes.successText]: !isError,
              })}
            >
              {contentText}
            </Typography>
            {(status === 'Error' || status === 'Success') && (
              <Typography variant='body2' className='mt-4'>
                {status === 'Error'
                  ? 'Please review error list for more details on unsynced items.'
                  : status === 'Success'
                  ? 'Would you like to start a new report?'
                  : ''}
              </Typography>
            )}
          </div>
        )}
      </Dialog.Content>

      <Dialog.Actions className='align-items-center'>
        {contentAction && (
          <Button
            onClick={contentAction || onClose}
            className='mb-4 bold-font mt-4'
            variant='contained'
            color='primary'
          >
            {contentActionText || ButtonText}
          </Button>
        )}
      </Dialog.Actions>
    </Dialog>
  );
};

export default ActionDialog;
